import React, { useEffect } from 'react'
import Button from '../../components/Button'
import useResponsive from '../../hooks/useResponsive'
const InterviewCompleted = () => {
    const isMobile = useResponsive('md');

    useEffect(() => {
      // Function to stop all media streams (camera and microphone)
      console.log('Stopping media stream, might take a while...');
      const stopMediaStreams = () => {
          // Stop all media streams globally
          navigator.mediaDevices.getUserMedia({ video: true, audio: true })
            .then((stream) => {
                stream.getTracks().forEach((track) => {
                    if (track.readyState === 'live') {
                        track.stop();
                    }
                });
            })
            .catch(() => {
                console.log('No active media streams found');
            });
      };

      // Stop media streams when component mounts
      stopMediaStreams();

      // Cleanup function to stop streams when component unmounts
      return () => {
          stopMediaStreams();
      };
    }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
        minHeight: 'calc(100vh - 250px)', 
      }}
    >
      <img
        src="/svgs/interview-completed.svg"
        alt="Success"
        style={{
          marginBottom: '2rem',
        }}
      />
      <h2
        style={{
          fontWeight: 500,
          fontSize: '1.2rem',
          whiteSpace: 'nowrap',
          textAlign: 'center',
        }}
      >
        Interview Already Completed
      </h2>{' '}
      <p style={{ fontSize: '0.9rem', color: '#6c757d' }}>
        This interview has already been completed, if you feel that this is
        {isMobile ? <>{' '} </> : <br />} 
        an error please reach out to <a href="mailto:jobseeker-support@jobtarget.com" style={{ color: '#0d6efd', textDecoration: 'underline' }}>JobSeeker Support</a>.</p>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
        <Button text="Close this tab" variant="outline-secondary" />
      </div>
    </div>
  )
}

export default InterviewCompleted
